/**
 * Single source of truth for which derived metric keys (health_metrics.name) can be
 * written to vitals when the user saves from Insights/Metrics.
 * Used by PatientDetailPage and PatientNutritionProfileTab.
 * Keys must match API metric_key (health_metrics.name from backend).
 */
export const VITAL_BACKED_DERIVED_METRICS: Record<string, string> = {
  body_weight_kg: 'Body Weight',
  bmi: 'BMI',
  body_fat_pct: 'Body Fat Percentage',
  body_fat_mass_kg: 'Body Fat Mass',
  fat_free_mass_kg: 'Fat Free Mass',
  skeletal_muscle_kg: 'Skeletal Muscle Mass',
  skeletal_muscle_pct: 'Skeletal Muscle %',
  protein_mass_kg: 'Body Protein Mass',
  protein_pct: 'Protein %',
  body_water_kg: 'Total Body Water',
  body_water_pct: 'Body Water %',
  intracellular_water_kg: 'Intracellular Water (ICW)',
  extracellular_water_kg: 'Extracellular Water (ECW)',
  ecw_tbw_ratio: 'ECW/TBW Ratio',
  mineral_mass_kg: 'Mineral Mass',
  bone_mass_kg: 'Bone Mass',
  phase_angle: 'Phase Angle',
  visceral_fat_level: 'Visceral Fat Level',
  basal_metabolic_rate_kcal: 'Basal Metabolic Rate (BMR)',
  body_age: 'Body Age',
  body_score: 'Body Score / Fitness Score',
  bsa: 'Body Surface Area',
  whtr: 'Waist-to-Height Ratio',
  whr: 'Waist-to-Hip Ratio',
  bai: 'Body Adiposity Index',
  bfp: 'Body Fat Percentage',
  lbm: 'Lean Body Mass',
  fm: 'Fat Mass',
  bmr: 'Basal Metabolic Rate',
  metabolic_age: 'Metabolic Age',
  vfi: 'Visceral Fat Index',
  smi: 'Skeletal Muscle Index',
  tbw: 'Total Body Water',
  bone_mass: 'Bone Mass',
  muscle_mass_kg: 'Muscle Mass',
  subcutaneous_fat_pct: 'Subcutaneous Fat %',
  fat_free_mass: 'Fat-Free Body Weight',
  sbp: 'Blood Pressure Systolic',
  dbp: 'Blood Pressure Diastolic',
  hrr: 'Heart Rate Recovery (1min)',
  vo2max: 'VO2 Max (Estimated)',
  rhr: 'Resting Heart Rate',
  hrv: 'Heart Rate Variability (RMSSD)',
  obesity_pct: 'Obesity %',
};
